// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__E52pR","dark":"BaseLayout_dark__SuH0w","light":"BaseLayout_light__d83mm"};